import script from "./TabsContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabsContent.vue?vue&type=script&lang=ts&setup=true"

import "./TabsContent.vue?vue&type=style&index=0&id=45ddc449&lang=scss"

const __exports__ = script;

export default __exports__